import styled from 'styled-components';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';

export const FormContainer = styled.div`
  position: relative;
`;

export const FormStyled = styled.form`
  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
`;

export const MoneyIconStyled = styled(AttachMoneyIcon)`
  color: ${(props) => props.theme.palette.primary.main};
`;
